import { DownloadInfoType, OrgType } from '@/types';
import { $get, $request, $delete } from '@/utils/request';

import servers from '../servers';

/**
 * @description: 设备字典上传
 */
export const uploadDeviceDictionaryRequestUrl = `${servers.base}/api/v1/space/spaceEquipDict/importEquipDictExcelVo`;

/**
 * @description: 设备字典 - 下载
 */
export const downloadDeviceDictionaryRequestUrl = `${servers.base}/api/v1/fileImport/download`;

/**
 * @description: 设备字典 - 历史上传记录list
 */
export const getDictionaryListRequest = (data = {}) => $request<ResponseData>({
  url: `${servers.base}/api/v1/fileImport/page`,
  method: 'post',
  data,
});

/**
 * @description: 设备导入历史 - 列表查询
 */
export const getDeviceImportHistoryListRequest = (data = {}) => $request<ResponseData>({
  url: `${servers.base}/api/v1/fileImport/deviceImportHistory/page`,
  method: 'post',
  data,
});

/**
 * @description: 设备导入历史 - 下载文件
 */
export const downloadDeviceImportHistoryFileRequest = (params = {}) => $request<ResponseData>({
  url: `${servers.base}/api/v1/fileImport/download`,
  method: 'get',
  params,
});

/**
 * @description: 全局设备列表 - 启用、禁用
 */
export const updateDeviceEnableRequest = (data = {}) => $request<ResponseData>({
  url: `${servers.dmpOpenAPI}/api/v1/device/status`,
  method: 'put',
  data,
});

/**
 * @description: 全局设备列表 - 获取运行设备列表 - 筛选条件子系统及设备类型
 */
export const getIBMSystemAndEquipTypeRequest = (data = {}) => $request<ResponseData>({
  url: `${servers.ibms}/api/insData/systemAndEquipTypes`,
  method: 'post',
  data,
});

/**
 * @description: 全局设备列表 - 运行设备 - 删除
 */
export const deleteIBMSDeviceRequest = (data = {}) => $request<ResponseData>({
  url: `${servers.ibms}/api/equipmentManagement/deleteEquipment`,
  method: 'post',
  data,
});

/**
 * @description: 全局设备列表 - 获取运行设备列表
 */
export const getIBMSDeviceListRequest = (data = {}) => $request<ResponseData>({
  url: `${servers.ibms}/api/equipmentManagement/getEquipmentList`,
  method: 'post',
  data,
});

/**
 * @description: 全局设备列表 - 获取运行设备详情
 */
export const getIBMSDeviceDetailRequest = (data = {}) => $request<ResponseData>({
  url: `${servers.ibms}/api/equipmentManagement/getEquipmentDetail`,
  method: 'post',
  data,
});

/**
 * @description: 全局设备列表 - 获取运行设备点位信息
 */
export const getIBMSDevicePointDetailRequest = (data = {}) => $request<ResponseData>({
  url: `${servers.ibms}/api/equipmentManagement/getPointsByEquipmentCode`,
  method: 'post',
  data,
});

/**
 * @description: 运行设备导入
 */
export const uploadIBMSDeviceRequestUrl = `${servers.ibms}/api/equipmentManagement/import`;

/**
 * @description: 运行设备导出
 */
export const exportIBMSDeviceRequestUrl = `${servers.ibms}/api/equipmentManagement/getFileUrl`;

/**
 * @description: 运行网关导入
 */
export const uploadIBMSGatewayRequestUrl = `${servers.ibms}/api/gatewayManagement/import`;

/**
 * @description: 运行网关导出
 */
export const exportIBMSGatewayRequestUrl = `${servers.ibms}/api/gatewayManagement/getFileUrl`;

/**
 * @description: 全局设备列表 - 获取运行网关列表
 */
export const getIBMSGatewayListRequest = (data = {}) => $request<ResponseData>({
  url: `${servers.ibms}/api/gatewayManagement/getGatewayEquipmentList`,
  method: 'post',
  data,
});

/**
 * @description: 全局设备列表 - 获取运行网关详情
 */
export const getIBMSGatewayDetailRequest = (data = {}) => $request<ResponseData>({
  url: `${servers.ibms}/api/gatewayManagement/getGatewayEquipmentDetail`,
  method: 'post',
  data,
});

/**
 * @description: 全局设备列表 - EMS设备导入
 */
export const uploadEMSDeviceRequestUrl = `${servers.backend}/api/v1/deviceMgt/meter/batchImportExcel`;

/**
 * @description: 全局设备列表 - 获取EMS设备列表
 */
export const getEMSDeviceListRequest = (data = {}) => $request<ResponseData>({
  url: `${servers.backend}/api/v1/deviceMgt/meter/page`,
  method: 'post',
  data,
});

/**
 * @description: 全局设备列表 - 获取EMS设备详情
 */
export const getEMSDeviceDetailRequest = (params = {}) => $request<ResponseData>({
  url: `${servers.backend}/api/v1/deviceMgt/meter/deviceDetail`,
  method: 'get',
  params,
});

/**
 * @description: 全局设备列表 - 获取EMS设备详情 - 业务信息
 */
export const getEMSDeviceBusinessDetailRequest = (params = {}) => $request<ResponseData>({
  url: `${servers.backend}/api/v1/deviceMgt/meter/businessDetail`,
  method: 'get',
  params,
});

/**
 * @description: 全局设备列表 - 获取EMS设备详情 - 点位信息
 */
export const getEMSDevicePointDetailRequest = (params = {}) => $request<ResponseData>({
  url: `${servers.backend}/api/v1/deviceMgt/meter/pointInfoDetail`,
  method: 'get',
  params,
});

/**
 * @description: 全局设备列表 - EMS网关导入
 */
export const uploadEMSGatewayRequestUrl = `${servers.backend}/api/v1/deviceMgt/gateway/import`;

/**
 * @description: 全局设备列表 - 获取EMS网关列表
 */
export const getEMSGatewayListRequest = (data = {}) => $request<ResponseData>({
  url: `${servers.backend}/api/v1/deviceMgt/gateway/page`,
  method: 'post',
  data,
});

/**
 * @description: 全局设备列表 - 获取EMS网关详情
 */
export const getEMSGatewayDetailRequest = (params = {}) => $request<ResponseData>({
  url: `${servers.backend}/api/v1/deviceMgt/gateway/detail`,
  method: 'get',
  params,
});

// 视频设备
/**
 * @description: 全局设备列表 - 视频网关导出
 */
export const exportVideoGatewayRequestUrl = `${servers.qdInsight}/api/v1/gateway/template`;

/**
 * @description: 全局设备列表 - 视频网关导入
 */
export const uploadVideoGatewayRequestUrl = `${servers.qdInsight}/api/v1/gateway`;

/**
 * @description: 全局设备列表 - 获取视频网关列表
 */
export const getVideoGatewayListRequest = (data = {}) => $request<ResponseData>({
  url: `${servers.qdInsight}/api/v1/gateway/page`,
  method: 'post',
  data,
});

/**
 * @description: 全局设备列表 - 视频网关删除
 */
export const deleteVideoGatewayRequest = (data = {}) => $request<ResponseData>({
  url: `${servers.qdInsight}/api/v1/gateway/deletion`,
  method: 'post',
  data,
});

/**
 * @description: 全局设备列表 - 摄像头导出
 */
export const exportVideoDeviceRequestUrl = `${servers.qdInsight}/api/v1/cameras/template`;

/**
 * @description: 全局设备列表 - 摄像头导入
 */
export const uploadVideoDeviceRequestUrl = `${servers.qdInsight}/api/v1/cameras`;

/**
 * @description: 全局设备列表 - 获取垂直空间列表
 */
export const getSpaceCodeParentListRequest = (data = {}) => $request<ResponseData>({
  url: `${servers.qdInsight}/api/v1/sys-dict/space-code`,
  method: 'post',
  data,
});

/**
 * @description: 全局设备列表 - 摄像头删除
 */
export const deleteVideoDeviceRequest = (data = {}) => $request<ResponseData>({
  url: `${servers.qdInsight}/api/v1/cameras/deletion`,
  method: 'post',
  data,
});

/**
 * @description: 全局设备列表 - 获取摄像头导入失败文件url
 */
export const getFailFileUrlRequest = (params = {}) => $request<ResponseData>({
  url: `${servers.qdInsight}/api/v1/cameras/file`,
  method: 'get',
  params,
});

/**
 * @description: 全局设备列表 - 摄像头禁用/恢复
 */
export const updateCameraEnableRequest = (data = {}) => $request<ResponseData>({
  url: `${servers.qdInsight}/api/v1/cameras`,
  method: 'put',
  data,
});

/**
 * @description: 全局设备列表 - 获取摄像头播放token
 */
export const getCameraTokenRequest = (data = {}) => $request<ResponseData>({
  url: `${servers.qdInsight}/api/v1/cameras/play-token`,
  method: 'post',
  data,
});

/**
 * @description: 全局设备列表 - 获取视频NVR设备列表
 */
export const getVideoNVRListRequest = (data = {}) => $request<ResponseData>({
  url: `${servers.qdInsight}/api/v1/nvr/page`,
  method: 'post',
  data,
});

/**
 * @description: 全局设备列表 - 视频NVR - 批量删除
 */
export const deleteVideoNVRRequest = (data = {}) => $request<ResponseData>({
  url: `${servers.qdInsight}/api/v1/nvr/deletion`,
  method: 'post',
  data,
});

/**
 * @description: 全局设备列表 - 获取视频网关-在离线日志
 */
export const getGatewayRecordRequest = (params = {}) => $request<ResponseData>({
  url: `${servers.videoBase}/common/api/gateway/queryGatewayReportLog`,
  method: 'get',
  params,
});

/**
 * @description: 全局设备列表 - 获取摄像头-在离线日志
 */
export const getDeviceRecordRequest = (params = {}) => $request<ResponseData>({
  url: `${servers.videoBase}/common/api/camera/queryCameraReportLog`,
  method: 'get',
  params,
});
